import { 
    setCookie, 
    getCookie
  } from '@/utils/cookie'
  
import {
    setLocalStorage,
    getLocalStorage
} from '@/utils/local-storage'

import moment from 'moment'

const HOLDER_LIST_HEADER_KEY = 'oiais_holder_list'

export const state = () =>({
    selected_headers: [ //已選的列表表頭
        { text: "投保人姓名", sortable: false, value: "holder_name" , width: '100px', selected: true},
        { text: "客戶等級", sortable: false, value: "level" , width: '50px', selected: true},         
        { text: "保單登記地址", sortable: false, value: "insurance_address" , width: '150px', selected: true},
        { text: "電話", sortable: false, value: "phone" , width: '80px', selected: true},
        { text: "聯絡地址", sortable: false, value: "connection_address" , width: '50px', selected: true},
        { text: "資料操作", sortable: false, value: "actions" , width: '50px', selected: true},
    ],
    total_headers: [ //可選的列表表頭
        { text: "投保人姓名", sortable: false, value: "holder_name" , width: '100px', selected: true},
        { text: "性別", sortable: false, value: "sex" , width: '20px', selected: false},
        { text: "出生日期", sortable: false, value: "birthday" , width: '50px', selected: false},         
        { text: "客戶等級", sortable: false, value: "level" , width: '50px', selected: true},         
        { text: "保單登記地址", sortable: false, value: "insurance_address" , width: '150px', selected: true},
        { text: "電話", sortable: false, value: "phone" , width: '80px', selected: true},
        { text: "Email", sortable: false, value: "email" , width: '50px', selected: false},
        { text: "聯絡地址", sortable: false, value: "connection_address" , width: '50px', selected: true},
        { text: "英文姓名", sortable: false, value: "eng_name" , width: '50px', selected: false},
        { text: "業務員姓名", sortable: false, value: "salesman_name" , width: '50px', selected: false},
    ],
})

export const getters ={
    getSelectedHolderListHeaders(state){
        var headers = state.selected_headers || getCookie(HOLDER_LIST_HEADER_KEY) || getLocalStorage(HOLDER_LIST_HEADER_KEY);
        if (headers == null) headers = []
        if (headers != []){
            if (state.selected_headers == []){
                state.selected_headers = headers
            }
        }
        return state.selected_headers
    },
    getAllHolderListHeaders: state => state.total_headers
}

export const mutations ={
    setSelectedHolderListHeaders(state, payload){
        state.selected_headers = payload
        state.selected_headers.push({ text: "資料操作", sortable: false, value: "actions" , width: '50px'})
        const now = moment();
        const expiredAt = now.add(1, 'minutes');
        setCookie({ 
            name: HOLDER_LIST_HEADER_KEY, 
            value: payload, 
            expiredAt: expiredAt 
        });
        //把token放到LocalStorage
        setLocalStorage({
            name: HOLDER_LIST_HEADER_KEY, 
            value: payload
        });
    }
}